import CustomerReviews from "@/Component/Common/CustomerReviews";
import DownloadNH from "@/Component/Common/DownloadNH";
import ExclusiveOffers from "@/Component/Common/ExclusiveOffers";
import MostBookedRoutes from "@/Component/Common/MostBookedRoutes";
import TopDeals from "@/Component/Common/TopDeals";
import MainLayout from "@/Component/MainLayout";
import Header from "@/Component/MainLayout/Header";
import { getCookie } from "@/utils/session";
import { generateSSO } from "@/utils/travelSwitchSso";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function FlightHome({ data = {}, mobile = false }) {
    const [sso, setsso] = useState(null)
    const token = getCookie("NHauth_token")
    const router = useRouter()

    useEffect(() => {
        const addSSO = async () => {
            const sso = await generateSSO(router.query);
            setsso(sso)
        };
        if (token || router.query?.emailId) {
            addSSO();
        }

    }, [router?.isReady, token]);
    return (
        mobile ?
            <>
                <Header hideNav={true} backgroundImage={"/assets/images/FlightBanner.png"} />
                <TopDeals initialSeasonalDeals={data.initialSeasonalDeals} />
                <ExclusiveOffers
                    initialCouponList={data.initialCouponList}
                    defaultModuleId="4" />
                <MostBookedRoutes sso={sso} />
                <CustomerReviews moduleType="Flight" initialReviewsList={data.initialReviewsList} />
            </>
            :
            <MainLayout headerBackgroundImage={"/assets/images/FlightBanner.png"}>
                <TopDeals initialSeasonalDeals={data.initialSeasonalDeals} />
                <ExclusiveOffers
                    initialCouponList={data.initialCouponList}
                    defaultModuleId="4"
                />
                <MostBookedRoutes sso={sso} />
                <CustomerReviews moduleType="Flight" initialReviewsList={data.initialReviewsList} />
                <DownloadNH />
            </MainLayout>
    );
}
